import { PAGES } from './routes';

export const app_slice_name = 'APP';

export const app_section_ids = {
  CLIENT_DETAILS: 'clientDetails',
  QUOTE: 'quote',
  CONTACT_DETAILS: 'contactDetails',
  UNDERWRITING: 'application',
  AMRA: 'amra',
  DECISION: 'decision',
  SETUP: 'setup',
};

export const app_section_names = {
  CLIENT_DETAILS: 'Client details',
  QUOTE: 'Quote',
  CONTACT_DETAILS: 'Contact details',
  UNDERWRITING: 'Application',
  AMRA: 'AMRA',
  DECISION: 'Decision',
  SETUP: 'Set-up',
};

export const SECTION_STATUS = {
  NOT_STARTED: 'notStarted',
  IN_PROGRESS: 'inProgress',
  INCOMPLETE: 'inComplete',
  COMPLETE: 'complete',
};

export const CLIENT_DETAILS_TAG = 'CLIENT_DETAILS';
export const OPTIONAL_TAG = 'OPTIONAL';
export const SMOKER_QUESTION_NAME = 'SMOKING_GFS';
export const DRESS_SIZE_QUESTION_NAME = 'DRESS_SIZE';
export const OCCUPATION_QUESTTION_NAME = 'OCCUPATION';
export const EARNINGS_QUESTION_NAME = 'EARNINGS';

export const app_sections = [
  {
    id: 'clientDetails',
    name: app_section_names.CLIENT_DETAILS,
    url: PAGES.CLIENT_DETAILS,
  },
  {
    id: 'quote',
    name: app_section_names.QUOTE,
    url: PAGES.QUOTE,
  },
  {
    id: 'contactDetails',
    name: app_section_names.CONTACT_DETAILS,
    url: PAGES.CONTACT_DETAILS,
  },
  {
    id: 'application',
    name: app_section_names.UNDERWRITING,
    url: PAGES.UNDERWRITING,
  },
  {
    id: 'amra',
    name: app_section_names.AMRA,
    url: PAGES.AMRA,
  },
  {
    id: 'decision',
    name: app_section_names.DECISION,
    url: PAGES.DECISION,
  },
  {
    id: 'setup',
    name: app_section_names.SETUP,
    url: PAGES.SET_UP,
  },
];

export const APPLICATION_STATUSES = {
  PRE_QUOTE: 'Create Quote',
  QUOTE: 'Quote',
  APPLY: 'Apply',
  DECISION: 'Decision',
  UNDERWRITING: 'Underwriting',
  WENT_ON_RISK: 'Went on Risk',
};

export const DASHBOARD_FILTERS = {
  PRE_QUOTE: 'Create Quote',
  QUOTE: 'Quote',
  APPLY: 'Apply',
  UNDERWRITING: 'Underwriting',
  DECISION: 'Decision',
};

export const APPLICATION_STATUSES_PAGE_MAP = {
  [APPLICATION_STATUSES.PRE_QUOTE]: PAGES.CLIENT_DETAILS,
  [APPLICATION_STATUSES.QUOTE]: PAGES.QUOTE,
  [APPLICATION_STATUSES.APPLY]: PAGES.APPLICATION,
  [APPLICATION_STATUSES.DECISION]: PAGES.DECISION,
  [APPLICATION_STATUSES.UNDERWRITING]: PAGES.DECISION,
  [APPLICATION_STATUSES.WENT_ON_RISK]: PAGES.COMPLETE,
};

export const APPLICATION_NBJ1_STATUSES_PAGE_MAP = {
  [APPLICATION_STATUSES.PRE_QUOTE]: 'planbuilder',
  [APPLICATION_STATUSES.QUOTE]: 'planquote',
  [APPLICATION_STATUSES.APPLY]: 'plandetails',
  [APPLICATION_STATUSES.DECISION]: 'decision',
  setup: 'setup',
  [APPLICATION_STATUSES.UNDERWRITING]: 'underwriting',
};

export const app_thunks = {
  APP_FETCH_CREATE_APPLICATION: `${app_slice_name}/fetchCreateApplication`,
  APP_POST_APPLICANT_BY_APPLICANT_ID: `${app_slice_name}/postApplicantApplicantById`,
  APP_PATCH_APPLICANT_BY_APPLICANT_ID: `${app_slice_name}/patchApplicantApplicantById`,
  APP_FETCH_APPLICATION_BY_ID: `${app_slice_name}/fetchApplicationById`,
  APP_POST_APPLICANT_COVER: `${app_slice_name}/postApplicantCover`,
  APP_PATCH_APPLICANT_COVER: `${app_slice_name}/patchApplicantCover`,
  APP_PATCH_APPLICANT_DECISION_COVER: `${app_slice_name}/patchApplicantDecisionCover`,
  APP_DELETE_APPLICANT_DECISION_COVER: `${app_slice_name}/deleteApplicantDecisionCover`,
  APP_DELETE_APPLICANT_COVER: `${app_slice_name}/deleteApplicantCover`,
  APP_POST_GET_QUOTE_PRICE: `${app_slice_name}/getQuotePrice`,
  APP_START_APPLICATION: `${app_slice_name}/postStartApplication`,
  APP_POST_APPLY_APPLICATION: `${app_slice_name}/postApplyApplication`,
  APP_GET_APPLICATION: `${app_slice_name}/getApplication`,
  APP_GET_APPLICATION_WITH_DECISIONS: `${app_slice_name}/getApplicationWithDecisions`,
  APP_POST_ADD_APPLICANT: `${app_slice_name}/postAddApplicant`,
  APP_POST_ACCEPT_PRE_UNDERWRITING_DECLARATION_BY_ID: `${app_slice_name}/postAcceptPreUnderwritingDeclarationById`,
  APP_POST_THIRD_PARTY_REFERENCE: `${app_slice_name}/postApplicationThirdPartyReference`,
  APP_POST_COMMISSION: `${app_slice_name}/postApplicationCommission`,
  APP_POST_MORTGAGE_RELATED: `${app_slice_name}/postApplicationMortgageRelated`,
  APP_DELETE_APPLICANT: `${app_slice_name}/deleteApplicantById`,
  APP_POST_IS_ADVISED_SALE: `${app_slice_name}/postApplicationIsAdvisedSale`,
  APP_POST_POLICY_START_DATE: `${app_slice_name}/postApplicationPolicyStartDate`,
  APP_POST_ACTIVATE_APPLICATION: `${app_slice_name}/postActivateApplication`,
  APP_GET_APPLICATION_STATUS: `${app_slice_name}/getApplicationStatus`,
  APP_FETCH_APPLICANT_CONTACT: `${app_slice_name}/fetchApplicantContact`,
  APP_POST_APPLICANT_CONTACT: `${app_slice_name}/postApplicantContact`,
  APP_POST_APPLICATION_CHILD: `${app_slice_name}/postApplicationChild`,
  APP_PUT_APPLICATION_CHILD: `${app_slice_name}/putApplicationChild`,
  APP_DELETE_APPLICATION_CHILD: `${app_slice_name}/deleteApplicationChild`,
  APP_POST_SAME_ADDRESS_APPLICANT_ID: `${app_slice_name}/postSameAddressApplicantId`,
  APP_POST_BANK_DETAILS: `${app_slice_name}/postBankDetails`,
  APP_GET_BANK_DETAILS: `${app_slice_name}/getBankDetails`,
  APP_POST_VALIDATE_BANK_DETAILS: `${app_slice_name}/postValidateBankDetails`,
  APP_POST_APPLICANT_COVER_ISPAYOUTPLANNERUSED: `${app_slice_name}/postApplicantCoverIsPayoutPlannerUsed`,
  APP_POST_APPLICATION_BENEFICIARY: `${app_slice_name}/postApplicationCoverBeneficiary`,
  APP_PUT_APPLICATION_BENEFICIARY: `${app_slice_name}/putApplicationCoverBeneficiary`,
  APP_POST_APPLICANT_COVER_BENEFICIARY_ALLOCATION: `${app_slice_name}/postApplicationCoverBeneficiaryAllocation`,
  APP_PUT_APPLICANT_COVER_BENEFICIARY_ALLOCATION: `${app_slice_name}/putApplicationCoverBeneficiaryAllocation`,
  APP_DELETE_APPLICANT_COVER_BENEFICIARY_ALLOCATION: `${app_slice_name}/deleteApplicationCoverBeneficiaryAllocation`,
  APP_POST_DECISION: `${app_slice_name}/postApplicationDecision`,
  APP_OPEN_APPLICATION_ANSWERS_DOCUMENT: `${app_slice_name}/openApplicationAnswersDocument`,
  APP_OPEN_DECISION_DOCUMENT: `${app_slice_name}/openDecisionDocument`,
  APP_OPEN_NBJ1_QUOTE_DOCUMENT: `${app_slice_name}/openNBJ1QuoteDocument`,
  APP_OPEN_NBJ1_APPLICATION_ANSWERS_DOCUMENT: `${app_slice_name}/openNBJ1ApplicationAnswersDocument`,
  APP_OPEN_NBJ1_DECISION_DOCUMENT: `${app_slice_name}/openNBJ1DecisionDocument`,
  APP_OPEN_KEYFACTS_DOCUMENT: `${app_slice_name}/openKeyFactsDocument`,
  APP_GET_UNDERWRITING_UPDATES: `${app_slice_name}/getApplicationUnderwritingUpdates`,
  APP_POST_APPLICATION_QUOTE_DATE: `${app_slice_name}/postApplicationQuoteDate`,
  APP_POST_HASUNBORNCHILDREN: `${app_slice_name}/postHasUnbornChildren`,
  APP_POST_PORTALAPPLY: `${app_slice_name}/postPortalApply`,
  APP_POST_UNLOCKQUOTEEDIT: `${app_slice_name}/postUnlockQuoteEdit`,
  APP_PATCH_APPLICANT_NAME: `${app_slice_name}/patchApplicantName`,
  APP_GET_APPLICATION_UNENRICHED: `${app_slice_name}/getApplicationUnenriched`,
  APP_PATCH_APPLICANT_CONTACT: `${app_slice_name}/patchContactDetails`,
  APP_OPEN_TERMSANDCONDITIONS_DOCUMENT: `${app_slice_name}/openTermsAndConditionsDocument`,
  APP_VALIDATE_APPLICANTS_COVERS: `${app_slice_name}/getApplicationValidateCovers`,
  APP_GET_ISTERMEXTENSIBLE: `${app_slice_name}/getIsTermExtensible`,
  APP_GET_DECLARATION_OF_HEALTH_QUESTIONS: `${app_slice_name}/triggerDeclarationOfHealthQuestions`,
  APP_POST_COMPLETE_TERM_EXTENSION: `${app_slice_name}/completeTermExtension`,
  APP_POST_HASFAILEDTERMEXTENSION: `${app_slice_name}/hasFailedTermExtension`,
  APP_POST_AMRA_CONSENT: `${app_slice_name}/postAmraConsentGranted`,
  APP_POST_AMRA_MEDICAL_REPORTS: `${app_slice_name}/postViewMedicalReportsRequested`,
  APP_PATCH_APPLICANT_EXAMINER_DETAILS: `${app_slice_name}/patchApplicantExaminerDetails`,
  APP_POST_OVERRIDE_BANK_VALIDATION: `${app_slice_name}/postOverrideBankValidation`,
  APP_POST_RESET_BANK_VALIDATION: `${app_slice_name}/postResetBankValidation`,
};

export const application_uw_fields = {
  gender: 'GENDER',
  dateOfBirth: 'BIRTHDATE',
  smoking: 'SMOKING_GFS',
};

export const application_uw_build_fields = {
  height: 'HEIGHT',
  waistMale: 'WEIGHT_MALE',
  weightFemale: 'WEIGHT_FEMALE',
  weightSize: 'WAIST_SIZE',
  dressSize: 'DRESS_SIZE',
};

export const applicant_qi_required_fields = ['gender', 'dateOfBirth'];

export const applicant_required_fields = [
  'title',
  'firstName',
  'lastName',
  'gender',
  'dateOfBirth',
];

export const application_cover_products = {
  LIFEESSENTIALS: 'lifeEssentials',
  LIFE: 'life',
  CIESSENTIALS: 'ciEssentials',
  CI: 'ci',
  ACIESSENTIALS: 'aciEssentials',
  ACI: 'aci',
  IP: 'ip',
  CCIC: 'ccic',
};

export const application_risk_types = {
  LIFE: 'life',
  CI: 'ci',
  TPD: 'tpd',
  LIFEESSENTIALS: 'altlife',
  CIESSENTIALS: 'altci',
};

export const application_cover_inputs = [
  'coverType',
  'term',
  'toAge',
  'coverAmount',
];

export const decimalFormatter = new Intl.NumberFormat('en-UK', {
  style: 'decimal',
  currency: 'GBP',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const moneyFormatter = new Intl.NumberFormat('en-UK', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 2,
});

export const formatter = new Intl.NumberFormat('en-UK', {
  style: 'currency',
  currency: 'GBP',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

export const toTitleCase = (str) =>
  str.replace(
    /(^\w|\s\w)(\S*)/g,
    (_, m1, m2) => m1.toUpperCase() + m2.toLowerCase()
  );

export const application_cover_inputs_format = {
  coverType: (value) => toTitleCase(value),
  monthlyBenefit: (value) => formatter.format(value),
  term: (value) => `${value} years`,
  toAge: (value) => `Age ${value}`,
  coverAmount: (value) => formatter.format(value),
  deferredPeriod: (value) => `${value} weeks`,
  paymentPeriod: (value) => (value === 'full' ? 'Full-term' : '2-year'),
  isTpdIncluded: (value) => (value ? 'Included' : 'Not included'),
};

export const application_cover_hidden_fields = {
  [application_cover_products.CCIC]: ['coverType'],
  [application_cover_products.IP]: ['coverAmount'],
  [application_cover_products.LIFE]: ['isTpdIncluded'],
  [application_cover_products.LIFEESSENTIALS]: ['isTpdIncluded'],
  [application_cover_products.ACI]: ['isTpdIncluded'],
  [application_cover_products.CI]: ['isTpdIncluded'],
  [application_cover_products.CCIC]: ['isTpdIncluded'],
  [application_cover_products.IP]: ['isTpdIncluded'],
};

export const privacyPolicyUrl = 'https://guardian1821.co.uk/privacy-policy/';
export const exampleEmailUrl =
  'https://content.guardian1821.co.uk/literature/client-welcome.pdf';

export const MAX_COVERS = 10;
export const MIN_AGE = 18;
export const MAX_AGE = 69;
export const CHILD_MAX_AGE = 23;
export const MAX_CHILDREN = 8;
export const BENEFICIARY_MAX_AGE = 100;
export const MAX_BENEFICIARIES = 8;
export const QUOTE_DATE_DAYS = 30;
export const ON_RISK_POLL_INTERVAL = 3;
export const ON_RISK_POLL_MAX = 60;
export const IP_MAX_AGE = 60;
export const NON_CI_ESSENTIALS_MAX_AGE = 65;

export const application_beneficiary_types = {
  CHILD: 'child',
  APPLICANT: 'applicant',
  BENEFICIARY: 'beneficiary',
};

export const IS_RESTRICTED_PAGES = [
  PAGES.CONTACT_DETAILS,
  PAGES.DECISION,
  PAGES.SET_UP,
];

export const coverSortOrder = [
  application_cover_products.LIFEESSENTIALS.toLowerCase(),
  application_cover_products.LIFE.toLowerCase(),
  application_cover_products.CIESSENTIALS.toLowerCase(),
  application_cover_products.CI.toLowerCase(),
  application_cover_products.ACIESSENTIALS.toLowerCase(),
  application_cover_products.ACI.toLowerCase(),
  application_cover_products.IP.toLowerCase(),
  application_cover_products.CCIC.toLowerCase(),
];

export const coverTypeSortOrder = [
  'level',
  'increasing',
  'decreasing',
  'family',
];

export const application_dress_sizes = [
  {
    id: 'uk',
    sizes: [4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26],
  },
  {
    id: 'european',
    sizes: [32, 34, 36, 38, 40, 42, 44, 46, 48, 50, 52, 54],
  },
  {
    id: 'us',
    sizes: [1, 2, 4, 6, 8, 10, 12, 14, 16, 18, 20, 22],
  },
  {
    id: 'australia',
    sizes: [4, 6, 8, 10, 12, 14, 16, 18, 20, 22, 24, 26],
  },
];

export const application_deferred_period_options = ['4', '8', '13', '26', '52'];

export const application_claim_period_options = ['full', '2 years'];
